import React, { useState, useMemo, useEffect, useContext } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import MUIDataTable from "components/mui-datatable";
import TableAllData from "components/Content/CustomTable/TableAllData";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ConfirmDialog from "components/Content/Modal/ConfirmDialog";
import ErrorIcon from '@mui/icons-material/Error';
import AximTooltip from "components/AximTooltip";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Slide,
    TextField,
    Typography,
    InputAdornment,
    IconButton,
    InputLabel, Select, MenuItem, FormControl
} from "@mui/material";

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from "@mui/material";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Utils } from "common/Utils";
import _ from 'lodash';
import moment from "moment";
import EmailTemplateDialog from "components/Content/Modal/EmailTemplateDialog";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { PrivateRoutesContext } from "app/PrivateRoutesContext";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
export default function EmailTemplate(props) {
    const { companyId, error,setCompany, setModalIsOpen } = useContext(PrivateRoutesContext);
    const [isLoading, setIsLoading] = useState(false);
    const [templates, setTemplates] = useState([]);

    const [isEmailTemplateDialogOpen, setIsEmailTemplateDialogOpen] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const [doShowConfirm, setDoShowConfirm] = useState(false);
    const [confirmCloseAction, setConfirmCloseAction] = useState(null);
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmText, setConfirmText] = useState('');
    const [confirmButtonsDisabled, setConfirmButtonsDiabled] = useState(false);
    const canEdit = true;
    const emailCategoryCode='CONTRACT-UPDATE';

  useEffect(() => {
    let selectedCompany = localStorage.getItem(`selectedCompanyId`);
    console.log(`current company ${selectedCompany}`)
    if (selectedCompany == null || selectedCompany === "") {
      setModalIsOpen(true)
    }
    else{
      setCompany(selectedCompany)
    }
    getEmailTemplates(selectedCompany);
  }, []);

    const closeTemplateDialog = () => {
        setIsEmailTemplateDialogOpen(false);
        getEmailTemplates(companyId);
    }

    const handleConfirmClose = (result) => {
        confirmCloseAction(result);
    }
    
    const getEmailTemplates = (companyId) => {
        setIsLoading(true);
        if(companyId!=null){
            apiGet(apiUrls.getEmailTemplateByCategory(companyId,emailCategoryCode)).then(
                (response) => {
                    setTemplates(response.data);
                    setIsLoading(false);
                }
            ).catch(
            (response) => {
                error.setTitle("An Error Occurred");
                error.setText("An Error occurred loading templates.");
                error.setDoShowError(true);
                setIsLoading(false);
            }
            );
        }
    }

    const columns = useMemo(() => [
        {
            id: "emailTemplateId",
            accessor: (cell) => <>
                <AximTooltip arrow title="Edit Template">
                    <IconButton color="primary" onClick={() => editTemplate(cell)}><EditOutlinedIcon /></IconButton>
                </AximTooltip>
                {cell.isTestEmailRequired ? 
                    <AximTooltip
                        arrow
                        title={"Test Email is required before Employee Emails can be sent"}
                    >
                        <ErrorIcon color="Red" />
                    </AximTooltip> : 
                    null}
            </>,
            disableFilters: true,
        },
        {
            Header: "Template",
            accessor: (cell) => <>
                {cell.emailTemplateDescription}
            </>,
        },
        {
            Header: "Update Date",
            accessor: (cell) => Utils.formatDate(cell.updateDate),
            Cell: ({row}) => (
              <Box>
                {Utils.formatDate(row.original.updateDate)}
              </Box>
            ),
            sortType: "dateSort",
        },
        {
            Header: "Update By",
            accessor: (cell) => `${cell.updateUserFirstName} ${cell.updateUserLastName}`,
        },
      ]);
      const newTemplate = () => {
          setSelectedTemplate(null);
          setIsEmailTemplateDialogOpen(true);
      }

      const editTemplate = (cell) => {
        setSelectedTemplate(cell);
        setIsEmailTemplateDialogOpen(true);
    }
    return (
        <>
        <Box>
            <Box className={TableStyle.tableWrapper}>
                <TableAllData columns={columns} data={templates} isLoading={isLoading}  
              />
            </Box>

            <EmailTemplateDialog isOpen={isEmailTemplateDialogOpen} handleClose={closeTemplateDialog} templateToEdit={selectedTemplate} showWelcomeEmailOption={false} allowCodeUpdate={false} />

            <ConfirmDialog
                doShowConfirm={doShowConfirm}
                handleClose={handleConfirmClose}
                confirmTitle={confirmTitle}
                confirmText={confirmText}
                buttonsDisabled={confirmButtonsDisabled} />
        </Box>
        </>
    )
}